/* Data аттрибут для имени метрики (формат: MetricClass:method[,OtherMetricClass:method] ) */
export var DATA_METRIC_NAME = 'data-metric-name';
/* Data аттрибут для установки режима работы метрики */
export var DATA_METRIC_MODE = 'data-metric-mode';
/* Data аттрибут (специфичный для mode=viewport) для настройки перекрытия */
export var DATA_METRIC_THRESHOLD = 'data-metric-viewport-threshold';
/* Data аттрибут (специфичный для mode=viewport) для настройки множественной отправки */
export var DATA_METRIC_ONCE = 'data-metric-viewport-once';
/* Data аттрибут с опциональной строковой информации */
export var DATA_METRIC_DATA = 'data-metric-data';